// "use client";

// import { useState, useEffect, useRef } from "react";
// import { User, ChevronDown } from "lucide-react";
// import type { SearchValues } from "../types";

// export function PeopleCountDropdown({
//   values,
//   setValues,
// }: {
//   values: SearchValues;
//   setValues: React.Dispatch<React.SetStateAction<SearchValues>>;
// }) {
//   const [open, setOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const ref = useRef<HTMLDivElement>(null);
//   const closeTimeoutRef = useRef<NodeJS.Timeout>(null);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth < 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     function onEsc(e: KeyboardEvent) {
//       if (e.key === "Escape") setOpen(false);
//     }
//     document.addEventListener("keydown", onEsc);
//     return () => document.removeEventListener("keydown", onEsc);
//   }, []);

//   useEffect(() => {
//     function handleClickOutside(event: MouseEvent) {
//       if (ref.current && !ref.current.contains(event.target as Node)) {
//         setOpen(false);
//       }
//     }
//     if (open) document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [open]);

//   useEffect(() => {
//     return () => {
//       if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
//     };
//   }, []);

//   const label = `${values.adults} adult${values.adults !== 1 ? "s" : ""} · ${values.children} children · ${values.rooms} room${values.rooms !== 1 ? "s" : ""}`;

//   return (
//     <div className="w-full relative" ref={ref}>
//       {/* ── Trigger ── */}
//       <button
//         type="button"
//         onClick={() => setOpen(!open)}
//         // ⚠️ was missing dark: bg + text
//         className="w-full flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 h-10 sm:h-11 bg-transparent text-left touch-manipulation cursor-pointer rounded-lg"
//       >
//         <User className="w-4 h-4 sm:w-5 sm:h-5 text-white dark:text-white flex-shrink-0" />
//         {/* ⚠️ was hardcoded text-gray-900 */}
//         <span className="flex-1 text-xs sm:text-sm text-white dark:text-white truncate">
//           {label}
//         </span>
//         <ChevronDown
//           className={`w-3.5 h-3.5 sm:w-4 sm:h-4 text-white dark:text-white flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
//         />
//       </button>

//       {open && (
//         <>
//           {/* Backdrop */}
//           <div
//             className="fixed inset-0 bg-black/20 dark:bg-black/40 z-40"
//             onClick={() => setOpen(false)}
//           />

//           {/* Dropdown panel */}
//           <div
//             className={[
//               "absolute z-50 overflow-hidden rounded-2xl min-w-[280px]",
//               // ⚠️ was fully missing dark: styles on this panel
//               "bg-white dark:bg-zinc-900",
//               "border-2 border-purple-600 dark:border-purple-500",
//               "shadow-2xl dark:shadow-zinc-950/60",
//               isMobile
//                 ? "left-1/2 -translate-x-1/2 top-full mt-2 max-h-[70vh] overflow-y-auto"
//                 : "left-1/2 -translate-x-1/2 top-full mt-2 max-h-[70vh] overflow-y-auto",
//             ].join(" ")}
//           >
//             <div className="p-4 sm:p-5 space-y-4 sm:space-y-5">
//               {[
//                 {
//                   key: "adults" as const,
//                   label: "Adults",
//                   sub: "Ages 13 or above",
//                   min: 1,
//                 },
//                 {
//                   key: "children" as const,
//                   label: "Children",
//                   sub: "Ages 2–12",
//                   min: 0,
//                 },
//                 { key: "rooms" as const, label: "Rooms", sub: "", min: 1 },
//               ].map(({ key, label, sub, min }) => (
//                 <div key={key} className="flex items-center justify-between">
//                   <div className="flex-1">
//                     {/* ⚠️ was missing dark: text */}
//                     <div className="font-medium text-sm sm:text-base text-gray-900 dark:text-zinc-100">
//                       {label}
//                     </div>
//                     {sub && (
//                       <div className="text-xs sm:text-sm text-gray-500 dark:text-zinc-400">
//                         {sub}
//                       </div>
//                     )}
//                   </div>
//                   <div className="flex items-center gap-3 sm:gap-4">
//                     <button
//                       onClick={() => {
//                         setValues((s) => ({
//                           ...s,
//                           [key]: Math.max(min, s[key] - 1),
//                         }));
//                         if (isMobile) {
//                           closeTimeoutRef.current = setTimeout(
//                             () => setOpen(false),
//                             500,
//                           );
//                         }
//                       }}
//                       disabled={values[key] <= min}
//                       // ⚠️ was missing dark: disabled + hover states
//                       className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-purple-500 dark:border-purple-400 text-purple-500 dark:text-purple-400 disabled:border-gray-300 dark:disabled:border-zinc-700 disabled:text-gray-300 dark:disabled:text-zinc-600 hover:bg-purple-50 dark:hover:bg-purple-900/30 active:bg-purple-100 dark:active:bg-purple-900/50 transition-colors flex items-center justify-center font-medium touch-manipulation text-lg cursor-pointer"
//                     >
//                       −
//                     </button>
//                     <span className="w-6 sm:w-8 text-center font-semibold text-base sm:text-lg text-gray-900 dark:text-zinc-100">
//                       {values[key]}
//                     </span>
//                     <button
//                       onClick={() => {
//                         setValues((s) => ({
//                           ...s,
//                           [key]: Math.min(
//                             key === "children" ? 10 : 30,
//                             s[key] + 1,
//                           ),
//                         }));
//                         if (isMobile) {
//                           closeTimeoutRef.current = setTimeout(
//                             () => setOpen(false),
//                             500,
//                           );
//                         }
//                       }}
//                       disabled={values[key] >= (key === "children" ? 10 : 30)}
//                       className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-purple-500 dark:border-purple-400 text-purple-500 dark:text-purple-400 disabled:border-gray-300 dark:disabled:border-zinc-700 disabled:text-gray-300 dark:disabled:text-zinc-600 hover:bg-purple-50 dark:hover:bg-purple-900/30 active:bg-purple-100 dark:active:bg-purple-900/50 transition-colors flex items-center justify-center font-medium touch-manipulation text-lg cursor-pointer"
//                     >
//                       +
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Footer */}
//             <div className="border-t border-gray-100 dark:border-zinc-800 bg-white dark:bg-zinc-900 px-4 sm:px-5 py-3 sm:py-4">
//               <button
//                 onClick={() => setOpen(false)}
//                 className="w-full bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-lg transition-colors py-2 sm:py-2.5 text-sm sm:text-base touch-manipulation cursor-pointer"
//               >
//                 Done
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

"use client";

import { useState, useEffect, useRef } from "react";
import { User, ChevronDown } from "lucide-react";
import type { SearchValues } from "../types";

export function PeopleCountDropdown({
  values,
  setValues,
  transparent = true,
}: {
  values: SearchValues;
  setValues: React.Dispatch<React.SetStateAction<SearchValues>>;
  transparent?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    function onEsc(e: KeyboardEvent) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    };
  }, []);

  const label = `${values.adults} ADULT${values.adults !== 1 ? "S" : ""}, ${values.children} CHILD${values.children !== 1 ? "REN" : ""}, ${values.rooms} ROOM${values.rooms !== 1 ? "S" : ""}`;
  return (
    <div className="w-full relative" ref={ref}>
      {/* ── Trigger ── */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 h-10 sm:h-11 bg-transparent text-left touch-manipulation cursor-pointer rounded-lg"
      >
        <User
          className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 ${
            transparent
              ? "text-white dark:text-white"
              : "text-gray-500 dark:text-zinc-400"
          }`}
        />
        <span
          className={`text-xs sm:text-sm whitespace-nowrap ${
            transparent
              ? "text-white dark:text-white"
              : "text-gray-900 dark:text-zinc-100"
          }`}
        >
          {label}
        </span>
        <ChevronDown
          className={`w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0 transition-transform ${
            transparent
              ? "text-white dark:text-white"
              : "text-gray-500 dark:text-zinc-400"
          } ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/20 dark:bg-black/40 z-40"
            onClick={() => setOpen(false)}
          />

          {/* Dropdown panel */}
          <div
            className={[
              "absolute z-50 overflow-hidden rounded-2xl min-w-[280px]",
              "bg-white dark:bg-zinc-900",
              "border-2 border-purple-600 dark:border-purple-500",
              "shadow-2xl dark:shadow-zinc-950/60",
              isMobile
                ? "left-1/2 -translate-x-1/2 top-full mt-2 max-h-[70vh] overflow-y-auto"
                : "left-1/2 -translate-x-1/2 top-full mt-2 max-h-[70vh] overflow-y-auto",
            ].join(" ")}
          >
            <div className="p-4 sm:p-5 space-y-4 sm:space-y-5">
              {[
                {
                  key: "adults" as const,
                  label: "Adults",
                  sub: "Ages 13 or above",
                  min: 1,
                },
                {
                  key: "children" as const,
                  label: "Children",
                  sub: "Ages 2–12",
                  min: 0,
                },
                { key: "rooms" as const, label: "Rooms", sub: "", min: 1 },
              ].map(({ key, label, sub, min }) => (
                <div key={key} className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="font-medium text-sm sm:text-base text-gray-900 dark:text-zinc-100">
                      {label}
                    </div>
                    {sub && (
                      <div className="text-xs sm:text-sm text-gray-500 dark:text-zinc-400">
                        {sub}
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-3 sm:gap-4">
                    <button
                      onClick={() => {
                        setValues((s) => ({
                          ...s,
                          [key]: Math.max(min, s[key] - 1),
                        }));
                        if (isMobile) {
                          closeTimeoutRef.current = setTimeout(
                            () => setOpen(false),
                            500,
                          );
                        }
                      }}
                      disabled={values[key] <= min}
                      className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-purple-500 dark:border-purple-400 text-purple-500 dark:text-purple-400 disabled:border-gray-300 dark:disabled:border-zinc-700 disabled:text-gray-300 dark:disabled:text-zinc-600 hover:bg-purple-50 dark:hover:bg-purple-900/30 active:bg-purple-100 dark:active:bg-purple-900/50 transition-colors flex items-center justify-center font-medium touch-manipulation text-lg cursor-pointer"
                    >
                      −
                    </button>
                    <span className="w-6 sm:w-8 text-center font-semibold text-base sm:text-lg text-gray-900 dark:text-zinc-100">
                      {values[key]}
                    </span>
                    <button
                      onClick={() => {
                        setValues((s) => ({
                          ...s,
                          [key]: Math.min(
                            key === "children" ? 10 : 30,
                            s[key] + 1,
                          ),
                        }));
                        if (isMobile) {
                          closeTimeoutRef.current = setTimeout(
                            () => setOpen(false),
                            500,
                          );
                        }
                      }}
                      disabled={values[key] >= (key === "children" ? 10 : 30)}
                      className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-purple-500 dark:border-purple-400 text-purple-500 dark:text-purple-400 disabled:border-gray-300 dark:disabled:border-zinc-700 disabled:text-gray-300 dark:disabled:text-zinc-600 hover:bg-purple-50 dark:hover:bg-purple-900/30 active:bg-purple-100 dark:active:bg-purple-900/50 transition-colors flex items-center justify-center font-medium touch-manipulation text-lg cursor-pointer"
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="border-t border-gray-100 dark:border-zinc-800 bg-white dark:bg-zinc-900 px-4 sm:px-5 py-3 sm:py-4">
              <button
                onClick={() => setOpen(false)}
                className="w-full bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-lg transition-colors py-2 sm:py-2.5 text-sm sm:text-base touch-manipulation cursor-pointer"
              >
                Done
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
